export const MARKET_CONSTS = {
    GET_MARKETS: "GET_MARKETS",
    CREATE_MARKET: "CREATE_MARKET",
    GET_MARKET_BY_ID: "GET_MARKET_BY_ID",
    UPDATE_MARKETS_POSITIONS: "UPDATE_MARKETS_POSITIONS",
    UPDATE_MARKET_BY_ID: "UPDATE_MARKET_BY_ID",
    DELETE_MARKET_BY_ID: "DELETE_MARKET_BY_ID",
    CLEAR_MARKET_DATA: "CLEAR_MARKET_DATA",
};
